import styled from 'styled-components';

import Paper from '@material-ui/core/Paper';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

const drawerWidth = '200px';

export const SidebarContainer = styled.div`
    ${({ theme }) => `
    background: ${theme.palette.primary.main};
    width: 200px;

    flex-direction: column;
    padding-top: 64px;
    padding-left: 15px;
    `}
`;

export const StyledPaper = styled(Paper)`
    ${({ theme }) => `
    background-color: ${theme.palette.primary.main};
    width: ${drawerWidth};
    border-radius: 0;
    border: none;
    box-shadow: none;
    margin-top: 60px;

    `}
`;

export const StyledBottomNavigation = styled(BottomNavigation)`
    ${({ theme }) => `
    position: fixed;
    bottom: 0;
    background: ${theme.palette.primary.main};
    width: 100%;
    max-width: 430px;
    height: 65px;
    box-shadow: 0px -4px 8px rgba(69, 74, 103, 0.1);
    backdrop-filter: blur(4px);
    border-radius: 16px;
    margin-top: 30px;

    z-index: 2;

`}
`;

export const StyledBottomNavigationAction = styled(BottomNavigationAction)`
    ${({ theme, $selected }) => `
    
    color: ${$selected ? theme.palette.common.white : theme.palette.common.dimBlue} !important;
    `}
`;
